import { useEffect, useRef, useState } from "react";
import moment from "moment";
import tinycolor from "tinycolor2";
import MoreIcon from "../../Assets/Icons/outline/more.svg";
import MoreWhiteIcon from "../../Assets/Icons/outline/more-white.svg";
import AddTaskIcon from "../../Assets/Icons/outline/profile-add.svg";
import EyeTaskIcon from "../../Assets/Icons/outline/eye.svg";
import DeleteTaskIcon from "../../Assets/Icons/outline/trash.svg";
import ProgressIcon from "../../Assets/Icons/bold/clock.svg";
import CheckIcon from "../../Assets/Icons/bold/tick-circle.svg";
import EditIcon from "../../Assets/Icons/outline/edit-2-black.svg";
import SaveIcon from "../../Assets/Icons/outline/save-2.svg";
import Button from "../../Components/Button";
import { isSuperAdmin, isSupervisorAndSuperAdmin } from "../../utils/auth";

const Timeline = ({ currentMonth, dataProject, line, handleShow, fullPage }) => {
	const scrollDemoRef = useRef(null);
	const [showMore, setShowMore] = useState({ show: false, id: null });

	useEffect(() => {
		if (scrollDemoRef.current && dataProject?.scroll) {
			scrollDemoRef.current.scrollLeft = dataProject?.scroll;
		}
	}, [dataProject]);

	return (
		<div
			className={`${
				fullPage ? "h-[calc(100vh-120px)]" : "h-[calc(100vh-140px)]"
			} w-full overflow-y-scroll overflow-x-scroll scrollbar relative`}
			ref={scrollDemoRef}
		>
			<div className="inline-block flex justify-between sticky top-0 bg-white z-40 w-max">
				{dataProject?.period?.map((item, index) => (
					<div className="border-b pb-1 min-w-[160px]" key={index}>
						<div
							className={`flex flex-col w-[65px] my-auto rounded-xl ${
								!item?.currentMonth ? "border-4 opacity-50 text-center py-1" : "py-1"
							} border-black`}
						>
							<div className="text-xl">{item?.day}</div>
							<div className="text-2xl font-semibold">{item?.number}</div>
						</div>
					</div>
				))}
				{moment().isSame(currentMonth, "month") && (
					<div className={`absolute top-0 z-30`} style={{ left: dataProject?.position + "px" }}>
						<div className="relative">
							<div className="px-4 pt-1 rounded-full border border-black font-semibold w-[80px] text-center">
								{moment().format("HH:mm")}
							</div>
							<div className="border-r border-black h-[750px] w-[40px]"></div>
						</div>
					</div>
				)}
			</div>
			<div className="flex justify-between relative">
				{dataProject?.graph?.map((item, index) => (
					<div className="pt-3 min-w-[160px]" key={index}>
						{item?.length > 0 &&
							item?.map((subItem, subIndex) => (
								<div
									key={subIndex}
									className={`${subItem?.first_of_start && "border-l rounded-l-full "} ${
										subItem?.last_of_end && "border-r rounded-r-full "
									} ${subItem && "border-y"} py-3.5 mb-6 min-h-[55px]`}
									style={{
										backgroundColor: subItem?.hex_code,
										color: tinycolor(subItem?.hex_code)?.isDark() ? " white" : " black",
									}}
								>
									<>
										{dataProject?.graph?.[index]?.[subIndex]?.id !==
											dataProject?.graph?.[index - 1]?.[subIndex]?.id && (
											<div
												className="absolute left-0 right-0 z-30 overflow-hidden px-8 flex items-center justify-between"
												style={{
													left: index * 160 + "px",
													width: subItem?.days * 160 + 20 + "px",
												}}
											>
												<div className="flex flex-col">
													<div className="font-semibold pb-0 leading-none">
														{`${subItem?.name?.substring(0, subItem?.days * 8)} (${
															subItem?.is_open === 1 ? "Open" : "Closed"
														})`}
														{subItem?.name?.length > subItem?.days * 8 && "..."}
													</div>
													<div className="text-xs pt-0 z-30 leading-none">
														{subItem?.description?.substring(0, subItem?.days * 12)}
														{subItem?.description?.length > subItem?.days * 12 && "..."}
													</div>
												</div>
												{subItem?.id && (
													<div className="relative flex">
														<div
															className="me-3"
															style={{
																color: tinycolor(subItem?.hex_code)?.isDark() ? " white" : " black",
															}}
														>
															{subItem?.total_task_done}/{subItem?.total_task} Task
														</div>
														<img
															src={subItem?.status === "On Progress" ? ProgressIcon : CheckIcon}
															alt=""
															className="w-[25px] h-[25px] border border-white rounded-full"
														/>
														<img
															role="button"
															src={tinycolor(subItem?.hex_code)?.isDark() ? MoreWhiteIcon : MoreIcon}
															alt=""
															className="rotate-90"
															onClick={() =>
																setShowMore((prevState) => {
																	return {
																		show: prevState?.show ? false : true,
																		id: prevState?.show ? null : subItem?.id,
																	};
																})
															}
														/>
													</div>
												)}
											</div>
										)}
										{subItem?.last_of_end && (
											<div
												className={`absolute mt-[50px] w-[230px] flex-col mt-2 mx-auto rounded-2xl border border-black bg-white mb-5 p-3 ${
													showMore?.show && showMore?.id === subItem?.id ? "flex" : "hidden"
												}`}
												style={{ zIndex: 50 }}
											>
												{subItem?.is_open === 1 && (
													<div className="mb-3">
														<Button
															className="text-base py-2.5 text-start"
															width={200}
															icon={AddTaskIcon}
															onClick={() => {
																handleShow(subItem?.id, "add task", subItem);
																setShowMore({ show: false, id: null });
															}}
														>
															Add Task
														</Button>
													</div>
												)}
												<div className="mb-3">
													<Button
														width={200}
														className="text-base py-2.5 text-start"
														icon={EyeTaskIcon}
														onClick={() => {
															handleShow(subItem?.id, "detail project", subItem);
															setShowMore({ show: false, id: null });
														}}
													>
														Detail Project
													</Button>
												</div>
												{isSupervisorAndSuperAdmin() && subItem?.is_open === 1 && (
													<>
														<div className="mb-3">
															<Button
																width={200}
																className="text-base py-2.5 text-start"
																icon={EditIcon}
																onClick={() => {
																	handleShow(subItem?.id, "update project", subItem, "project");
																	setShowMore({ show: false, id: null });
																}}
															>
																Update Project
															</Button>
														</div>
														<div className="mb-3">
															<Button
																width={200}
																className="text-base py-2.5 text-start"
																icon={DeleteTaskIcon}
																onClick={() => {
																	handleShow(subItem?.id, "delete", null, "project");
																	setShowMore({ show: false, id: null });
																}}
															>
																Delete Project
															</Button>
														</div>
													</>
												)}
												{isSuperAdmin() && subItem?.is_open === 1 && (
													<div>
														<Button
															width={200}
															className="text-base py-2.5 text-start"
															icon={SaveIcon}
															onClick={() => {
																handleShow(subItem?.id, `close project`, subItem, "project");
																setShowMore({ show: false, id: null });
															}}
														>
															Close Project
														</Button>
													</div>
												)}
											</div>
										)}
									</>
								</div>
							))}
					</div>
				))}
				<div className={`absolute top-0`}>
					{line?.map((item, key) => (
						<div key={key} className="flex justify-between relative">
							{dataProject?.graph?.map((subItem, subIndex) => (
								<div key={subIndex} className="min-w-[160px] border-b pt-3 h-[80px]"></div>
							))}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Timeline;
